<template>
  <div class="d-lg-flex">
    <div class="w-100 user-chat">
      <div class="card">
        <div class="chat-users">
          <div class="chat-conversation p-3" :class="chatBoxData.length == 0 && 'd-flex align-items-center'">
            <div v-if="chatBoxData.length > 0" style="max-height: 470px; overflow-y: scroll" id="containerElement" ref="current" @scroll="onScroll">
              <ul class="list-unstyled" v-for="items in chatBoxData" :key="items.date">
                <li>
                  <div class="chat-day-title">
                    <span class="title">{{ FormatedDate(items.date) }}</span>
                  </div>
                </li>
                <li v-for="data of items.callLogs" :key="data.id" :class="{ right: `${data.isMyRecord}` === 'right' }">
                  <div
                    class="conversation-list col-11 col-lg-11"
                    :class="{
                      'float-end': !data.isMyRecord,
                      'float-start': data.isMyRecord,
                    }"
                  >
                    <div class="ctext-wrap">
                      <div class="flexDiv" :class="{ fDirectionReverse: data.isMyRecord }">
                        <div class="conversation-name">
                          <span class="conversation-name">
                            <!-- {{ data.isMyRecord ? data.caller.fullName : data.responder.fullName  }} right code -->
                            {{ data.isMyRecord ? data.caller.fullName : data.caller.fullName }}
                          </span>
                        </div>
                        <p class="chat-time mb-0">
                          <i class="far fa-clock align-middle me-1"></i>
                          {{ convertTime(data.answerDateTime) }}
                        </p>
                      </div>
                      <div class="flexDiv" :class="{ fDirectionReverse: !data.isMyRecord }">
                        <AudioDiv :file="data.address" />
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-1 col-1 float-end">
                    <div class="imgDiv">
                      <img :src="data.isMyRecord ? data.caller.image : data.caller.image" class="float-end" alt="" width="30" />
                      <!-- data.isMyRecord ? data.caller.image : data.responder.image right code -->
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <div v-else class="w-100">
              <Loader :loading="loading" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AudioDiv from './audio/audioDiv'
import Loader from '../common/loader.vue'

export default {
  components: {
    AudioDiv,
    Loader,
  },
  page: {
    title: 'جزئیات کاربر',
    meta: [
      {
        name: 'description',
        content: '',
      },
    ],
  },
  props: {
    chatBoxData: {
      type: Array,
    },
  },
  data() {
    return {
      loading: true,
    }
  },
  computed: {},
  methods: {
    onLoad() {
      setTimeout(() => {
         this.loading = false
      }, 1000)
    },
    onScroll({ target: { scrollTop, clientHeight, scrollHeight } }) {
      if (scrollTop + clientHeight >= scrollHeight) {
        this.$emit('loadMoreData')
      }
    },
  },
  mounted(){
    this.onLoad()
  }
}
</script>

<style scoped>
.empty-table {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  margin-top: 70px;
  background-color: white;
  flex-direction: column;
}
.empty-table-text {
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 26px;
  letter-spacing: 0px;
}
::-webkit-scrollbar {
  display: none;
}
.chat-conversation .conversation-list .ctext-wrap .conversation-name p {
  color: #555555;
  font-weight: 500;
}
.ctext-wrap {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 12px !important;
}
.chat-conversation .conversation-list .ctext-wrap {
  background-color: #fafafa !important;
}
.chat-conversation {
  min-height: 502px;
}
.flexDiv {
  display: flex;
  justify-content: space-between;
}
.fDirectionReverse {
  flex-direction: row-reverse !important;
}
.imgDiv {
  float: right;
}
.imgDiv img {
  border-radius: 100% !important;
}
.pTextError {
  color: #f46a6a !important;
}
.pTextSuccess {
  color: #34c38f !important;
}
.conversation-tag {
  color: #556ee6;
  font-size: 15px !important;
  font-weight: 600;
}
.conversation-tag p .pTextSuccess,
.conversation-tag p .pTextError {
  font-size: 15px;
}
.chat-conversation .right {
  float: none !important;
}
.conversation-name {
  font-size: 13px;
}
.chat-conversation .chat-day-title .title {
  background-color: #f8f8fb;
  color: #556ee6;
}
</style>
